import React from 'react';
import Modal from './Modal';

/**
 * "Leave This Page?" confirmation. Leaving cancels the open import batch on the
 * backend, so the admin has to acknowledge losing the progress first.
 */
const LeavePageModal = ({ isOpen, onLeave, onStay, submitting = false }) => (
  <Modal isOpen={isOpen} onClose={submitting ? undefined : onStay}>
    <div className='px-6 py-5 border-b border-gray-200'>
      <h2 className='text-xl font-bold text-gray-900'>Leave This Page?</h2>
    </div>

    <div className='px-6 py-5'>
      <p className='text-sm text-gray-700'>
        If you leave this page, the ongoing process will be canceled and your
        progress will be lost.
      </p>

      <div className='mt-6 flex items-center justify-end gap-3'>
        <button
          type='button'
          onClick={onLeave}
          disabled={submitting}
          className='border border-gray-300 text-gray-700 px-5 py-2.5 rounded-md text-sm font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed'
        >
          {submitting ? 'Leaving...' : 'Leave Page'}
        </button>
        <button
          type='button'
          onClick={onStay}
          disabled={submitting}
          className='bg-blue-600 text-white px-5 py-2.5 rounded-md text-sm font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed'
        >
          Stay on Page
        </button>
      </div>
    </div>
  </Modal>
);

export default LeavePageModal;
